export default {
  

  AloxaLogo: require("../images/AloxaAI.png"),
  alopexiaLogo: require("../images/loginpgimgs/alopexia-logo.png"),

  frontView: require("../images/frontview.png"),
  TopView: require("../images/topview.png"),
  LeftView: require("../images/leftview.png"),
  RightView: require("../images/rightview.png"),

  DocProfile : require("../images/doctor.png"),
  rejectIcon : require("../images/DeleteView.png"),
  photoDoc : require("../images/passportImg.png"),
  // country flag 
  austria: require("../images/loginpgimgs/Austria.png"),
    belgium: require("../images/loginpgimgs/Belgium.png"),
    denmark: require("../images/loginpgimgs/Denmark.png"),
    finland: require("../images/loginpgimgs/Finland.png"),
    france: require("../images/loginpgimgs/France.webp"),
    germany: require("../images/loginpgimgs/Germany.png"),
    greece: require("../images/loginpgimgs/Greece.webp"),
    italy: require("../images/loginpgimgs/Italy.png"),
    netherlands: require("../images/loginpgimgs/Netherlands.png"),
    norway: require("../images/loginpgimgs/Norway.png"),
    poland: require("../images/loginpgimgs/Poland.png"),
    portugal: require("../images/loginpgimgs/Portugal.png"),
    spain: require("../images/loginpgimgs/Spain.png"),
    sweden: require("../images/loginpgimgs/Sweden.png"),
    switzerland: require("../images/loginpgimgs/Switzerland.webp"),
    flag1: require("./loginpgimgs/India_flag.png"),
    passportSampleImg: require("../images/passportsampleImg.jpg"),
  
  };
  